export default {
    apiKey: "AIzaSyCUuVbGFtWyC01zAwpx6gZ0DdIeiMgXRUI",
    authDomain: "simonyiutiovoda.firebaseapp.com",
    projectId: "simonyiutiovoda",
    storageBucket: "simonyiutiovoda.appspot.com",
    messagingSenderId: "85705567192",
    appId: "1:85705567192:web:0eae8db691d5a7f402e0ad",
    measurementId: "G-NKFWQYJPNQ"
}